/* eslint-disable camelcase */
import { navigate } from "utils/routing/NavRouter";
import { screenNames } from "screens/LoginRegistration/utils/constants";
import { LOGGED_IN_USER_DATA } from "screens/LoginRegistration/queries";
import { graphQLQueryHelper } from "utils/graphQL";
import { genderEnum } from "screens/LoginRegistration/components/BasicDetailComponent/utils";
import { Platform } from "react-native";
import { GetStorage } from "screens/common/LocationContext/storage";
import getData from "utils/getData";
import {
  setCookieUniversal,
  deleteCookieUniversal,
  getCookieUniversal
} from "./cookie";

const FLOW_COMPETED_COOKIE_NAME = "flow_completed";

export const utmCookies = [
  "utm_source",
  "utm_page",
  "utm_medium",
  "utm_campaign",
  "http_referer",
  "utm_term",
  "utm_content",
  "gclid"
];

export const createFlowCompletedCookie =
  (res = undefined) =>
  () => {
    setCookieUniversal(FLOW_COMPETED_COOKIE_NAME, "ajflowcompletev1", res);
  };

export const removeFlowCompletedCookie =
  (res = undefined) =>
  () => {
    deleteCookieUniversal(FLOW_COMPETED_COOKIE_NAME, res);
  };

export const navigateToLoggedIn = async ({ query, user, authSignIn }) => {
  const jobCardLocation = await GetStorage("locationMissmatchCheck");
  const jsonLocation = jobCardLocation ? JSON.parse(jobCardLocation) : "";

  const route = (query && (query.route || query.next)) || "dashboard";
  const params = query && query.params ? JSON.parse(query.params) : {};

  if (Platform.OS === "web") {
    createFlowCompletedCookie(undefined)(); // push this cookie so that we really know that the flow is completed
  }
  if (Platform.OS === "android" && authSignIn) {
    authSignIn(user.access_token);
  }

  if (jsonLocation && jsonLocation > 100) {
    navigate("dashboard", {}, "hardPush");
  } else {
    navigate(route, params, "hardPush"); // make sure this is a hard push for apollo cache, service worker reset
  }
};

export const getUTMObject = () => {
  const utmValues = utmCookies.map((name) => getCookieUniversal(name));
  const utmObject = utmCookies.reduce((obj, name, index) => {
    if (utmValues[index]) {
      obj[name] = utmValues[index];
    }
    return obj;
  }, {});
  return utmObject;
};

export const isFAandFAExperienceMatching = (
  functional_areas,
  fa_experience
) => {
  // Check if both are defined
  if (!functional_areas || !fa_experience) {
    return false;
  }
  // Check if both have equal length
  if (fa_experience.length !== functional_areas.length) {
    return false;
  }
  // Check if each individual FAs are matching
  const FAIds = functional_areas.map((item) => item.id);
  for (let i = 0; i < fa_experience.length; i += 1) {
    const id = fa_experience[i].functional_area.id;
    if (FAIds.indexOf(id) === -1) {
      return false;
    }
  }
  // Otherwise return true
  return true;
};

export const isRegistrationIncomplete = (user, variant) => {
  const candidate = user ? user.stakeholder : null;
  // eslint-disable-next-line no-param-reassign
  variant = variant || "A"; //TODO:REMOVE HARDCODED
  // Check for basic detail screen
  // if (
  //   !candidate ||
  //   !user.first_name ||
  //   (user.gender !== genderEnum.MALE && user.gender !== genderEnum.FEMALE) ||
  //   !user.date_of_birth ||
  //   !candidate.educations ||
  //   (candidate.educations && candidate.educations.length === 0)
  // ) {
  //   return screenNames.BasicDetailComponent;
  // }

  if (
    !candidate ||
    !user.first_name ||
    !Object.values(genderEnum).includes(user.gender)
  ) {
    return screenNames.BasicDetailComponent;
  }

  //check for education and workexperience
  if (
    !candidate.educations ||
    (candidate.educations &&
      candidate.educations.length === 0 &&
      variant === "A")
  ) {
    return screenNames.ProfessionalDetailComponent;
  }

  // Check for FA screen
  if (
    !candidate.functional_areas ||
    (candidate.functional_areas && candidate.functional_areas.length === 0)
  ) {
    return screenNames.FAComponent;
  }

  // Check for FA experience screen
  // if (
  //   typeof candidate.is_experienced_feedback !== "boolean" ||
  //   (candidate.is_experienced_feedback &&
  //     (!candidate.current_company ||
  //       !candidate.total_experience ||
  //       (candidate.total_experience > 0 &&
  //         (!candidate.fa_experience ||
  //           !isFAandFAExperienceMatching(
  //             candidate.functional_areas,
  //             candidate.fa_experience
  //           )))))
  // ) {
  //   return screenNames.WorkExperienceComponent;
  // }

  //Check for location screen
  // if (
  //   !candidate.address ||
  //   (candidate.address &&
  //     !(candidate.address.address_text || candidate.address.locality))
  // ) {
  //   return screenNames.LocationComponent;
  // }

  return false;
};

export const getUserDetails = async ({ apolloClient, authToken }) => {
  let user = {};
  if (authToken) {
    return graphQLQueryHelper(apolloClient)({
      query: LOGGED_IN_USER_DATA
    });
  }
};

// Clean the Code below =============> remove the part not being used
const processInput = {
  mobile: (input) => {
    let output = "";
    output = input.replace(/^(\+91|0)/g, ""); // remove +91 or 0 at the start
    output = output.replace(/(\s|-)/g, ""); // replace whitespace chars or dashes
    return output;
  },
  name: (input) => {
    return input.replace(/\s+/g, " ");
  }
};

export const cleanInput = (type, input) => {
  if (!input) {
    return "";
  }
  const mid = input.trim();

  if (type === "mobile" || type === "name") {
    return processInput[type](mid);
  }

  return mid;
};

export const validateNumericEntry = (str) => {
  return str.match(/^[0-9]*$/) !== null;
};

export const validateAlphabheticEntry = (str) => {
  return str.match(/^[A-Za-z\s]*$/) !== null;
};

// ---------------- Check Valid Mobile  -------------------  //

export const isValidMobile = (str) =>
  str.match(/^(\+91)?[6-9][0-9]{9}$/) !== null;

// ---------------- Check Valid Full Name  -------------------  //
export const isValidName = (str) => {
  const letters = /^[A-Za-z\s]+$/;
  return str.match(letters) !== null;
};

// ---------------- Default Error message -------------------  //
export const defaultError = "Network Error. Please try again";

// ====================================================================================================================================================================================
// ---------------- Check Valid Email -------------------  //
/* eslint-disable */
export const isValidEmail = (str) => {
  return (
    str.match(
      /^[-a-z0-9~!$%^&*_=+}{\'?]+(\.[-a-z0-9~!$%^&*_=+}{\'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*\.(aero|arpa|biz|com|coop|edu|gov|info|int|mil|museum|name|net|org|pro|travel|mobi|in|global|[a-z][a-z])|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/
    ) !== null
  );
};
/* eslint-enable */

// ----------- Check OTP ------------- //

export const isValidOTP = (str) => {
  const digits = /^\d+$/;
  return str.match(digits) !== null;
};
